import { generateUUID } from '../utils/generateUUID';
import { STEP_PREFIXES } from './constants';
import { getStepByUUID } from './selectors';
import { isChoiceStep, isOfType } from './stepUtils';
import { StepClass } from './types';
export function create(partial = {}) {
    return Object.assign({ uuid: generateUUID(STEP_PREFIXES[StepClass.PreferenceTest]), className: StepClass.PreferenceTest, title: null, description: [], choices: [], choiceDefinitions: {}, conditions: {
            rules: [],
            ALWAYS: null,
        }, isRequired: false, randomize: false, revision: 0, selectionRange: [null, null] }, partial);
}
export function setChoiceTitle(mutable, index, value) {
    const choiceUUID = mutable.choices[index];
    mutable.choiceDefinitions[choiceUUID].choiceTitle = value;
}
export function getChoiceTitle(userTest, stepUUID, choiceUUID) {
    if (!stepUUID)
        return null;
    const step = getStepByUUID(userTest, stepUUID);
    if (!step || !isOfType(step, StepClass.PreferenceTest))
        return null;
    return step.choiceDefinitions[choiceUUID].choiceTitle;
}
export function getPreferenceChoiceUUID(userTest, stepUUID, choiceValue) {
    const step = userTest.stepDefinitions[stepUUID];
    if (!step || !isChoiceStep(step))
        return null;
    const choiceUUID = Object.keys(step.choiceDefinitions).find((key) => {
        var _a;
        return ((_a = step.choiceDefinitions[key]) === null || _a === void 0 ? void 0 : _a.choiceTitle) === choiceValue;
    });
    return choiceUUID || null;
}
export * from './choiceStepUtils';
